// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI);

/* eslint-disable no-new */
let vue =new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export const vueInstance = vue
export const storeInstance = store


// WEBPACK FOOTER //
// ./src/main.js